import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BasicComponent } from './basic/basic.component';
import { FacultyFilterModule } from './faculty-filter/faculty-filter.module';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './_shared/header/header.component';

@NgModule({
  declarations: [
    AppComponent,
    BasicComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FacultyFilterModule,
    HttpClientModule,
  ],
  providers: [HttpClientModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
